var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApplicationProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15a1 1 0 01-1 1H1a1 1 0 01-1-1V9a1 1 0 011-1h6a1 1 0 011 1v2h3V8H9a1 1 0 01-1-1V1a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1h-2v3h7a1 1 0 011 1v4.001h2a1 1 0 011 1V23a1 1 0 01-1 1h-6a1 1 0 01-1-1v-5.999a1 1 0 011-1h2V13H8v2zm14 3.001h-4V22h4v-3.999zM6 10H2v4h4v-4zm8-8h-4v4h4V2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconApplicationProfile;